import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '@/store'
import { REPORT_DEFS, REPORT_ORDER } from './reportDefs'

/** Navegación entre los tres reports, dentro del módulo. */
export function ReportsTabs() {
  const { t } = useTranslation()
  const dark = useAppStore(s => s.dark)

  const base = 'px-3 py-1.5 text-[12px] font-semibold rounded-lg transition-colors whitespace-nowrap'

  return (
    <nav className="flex flex-wrap gap-1" aria-label={t('reports.title')}>
      {REPORT_ORDER.map(key => {
        const def = REPORT_DEFS[key]
        return (
          <NavLink
            key={key}
            to={`/reports/${def.route}`}
            className={({ isActive }) =>
              isActive
                ? `${base} ${dark ? 'bg-sky-500/15 text-sky-300' : 'bg-sky-50 text-sky-700'}`
                : `${base} ${dark ? 'text-slate-400 hover:bg-white/5' : 'text-slate-500 hover:bg-slate-100'}`
            }
          >
            {t(def.tabKey)}
          </NavLink>
        )
      })}
    </nav>
  )
}
